module.exports = __webpack_public_path__ + "2bd470bf3f1ab932f01a9b1625944989.svg";